import alerts from './alerts-locale';
import amlTraining from './aml-training-locale';
import config from './config-locale';
import exchange from './exchange-locale';
import labels from './labels-locale';
import myAccount from './my-account-locale';
import prescreening from './prescreening-locale';
import rbtm from './rbtm-locale';
import riskAssessment from './risk-assessment-locale';
import sar from './sar-locale';
import userManagement from './user-management-locale';

export default {
  alerts,
  amlTraining,
  config,
  exchange,
  labels,
  myAccount,
  prescreening,
  rbtm,
  riskAssessment,
  sar,
  userManagement,
};
